import { RestClient } from "clients/rest";
import { getFormData } from "../RestClient";

export type B010050CheckRequest = {
  csvFileData: File;
};

export type B010050CheckResponse = {
  torikomikeka: string;
  csvFileNm: string;
  ediJuchuDataList: B010050EdiJuchuData[];
  displayDataList: B010050DisplayData[];
};

export type B010050EdiJuchuData = Partial<{}>;

export type B010050DisplayData = {
  denpyoNo: string;
  tokuiNm: string;
  juchuYmd: string;
  meisaisu: string;
  biko: string;
};

//TO DO 製造され次第名前変更
export type B010050ImportGenericRequest = {
  shukayoteiYmd: string;
  denpyoYmd: string;
  nohinyoteiYmd: string;
  shainCd: string;
  asistantCd: string;
  csvFileNm: string;
  denpyoNoList: string[];
  ediJuchuDataList: B010050EdiJuchuDataRequest[];
} & Partial<{
  seisakuYmd: string;
}>;

//TO DO 製造され次第名前変更
export type B010050EdiJuchuDataRequest = {
  juchuNo: string;
  juchuYmd: string;
  tokuiCd: string;
  tokuishitenCd: string;
  chohaKbn: string;
  shohinCd: string;
  juchusu: string;
} & Partial<{
  nonyuCd: string;
  nonyushitenCd: string;
  seisakuYmd: string;
  denpyoYmd: string;
  shukayoteiYmd: string;
  nohinyoteiYmd: string;
  biko: string;
  edimemo: string;
  chumonNo: string;
  hinbetsuNo: string;
  nohinsaki: string;
  uribaNm: string;
  naisen: string;
  tantosha: string;
  lineCd: string;
  nonyuNm: string;
  nonyuPostCd: string;
  nonyuAddress1: string;
  nonyuAddress2: string;
  nonyuTelNo: string;
  nonyuFaxNo: string;
  juchutanka: string;
  juchuKin: string;
  jodaitanka: string;
  kakeritsu: string;
  meisaibiko: string;
}>;

// 受注ワーク取込(汎用)呼び出し処理
export const B010050ImportGeneric = (props: B010050ImportGenericRequest) => {
  return RestClient.post("b010050/import/generic", props);
};

//TO DO 製造され次第名前変更
export type B010050ImportHandsRequest = {
  shukayoteiYmd: string;
  denpyoYmd: string;
  nohinyoteiYmd: string;
  shainCd: string;
  asistantCd: string;
  csvFileNm: string;
  denpyoNoList: string[];
  ediJuchuDataList: B010050EdiJuchuDataHandsRequest[];
} & Partial<{
  seisakuYmd: string;
}>;

//TO DO 製造され次第名前変更
export type B010050EdiJuchuDataHandsRequest = {
  hachuYmd: string;
  miseCd: string;
  torihikiShohinCd: string;
  hachusu: string;
  denpyoNo: string;
  tokuiCd: string;
  tokuishitenCd: string;
} & Partial<{
  shohinNm1: string;
  shohinNm2: string;
  gentanka: string;
  uritanka: string;
  denpyoGyo: string;
  floarNm: string;
  nohinbasho: string;
  tekiyo1: string;
  tekiyo2: string;
}>;

// 受注ワーク取込(ハンズ)呼び出し処理
export const B010050ImportHands = (props: B010050ImportHandsRequest) => {
  return RestClient.post("b010050/import/hands", props);
};

//TO DO 製造され次第名前変更
export type B010050ImportLoftRequest = {
  shukayoteiYmd: string;
  denpyoYmd: string;
  nohinyoteiYmd: string;
  shainCd: string;
  asistantCd: string;
  csvFileNm: string;
  denpyoNoList: string[];
  ediJuchuDataList: B010050EdiJuchuDataLoftRequest[];
} & Partial<{
  seisakuYmd: string;
}>;

//TO DO 製造され次第名前変更
export type B010050EdiJuchuDataLoftRequest = {
  hachuTenpo: string;
  hachuYmd: string;
  denpyoNo: string;
  hinbetsuNo: string;
  janCd: string;
  hachusu: string;
  tokuiCd: string;
  tokuishitenCd: string;
} & Partial<{
  juchuYmd: string;
  juchuTime: string;
  biko: string;
  shohinNm: string;
  hachugentanka: string;
  hachuuritanka: string;
}>;

// 受注ワーク取込(ロフト)呼び出し処理
export const B010050ImportLoft = (props: B010050ImportLoftRequest) => {
  return RestClient.post("b010050/import/loft", props);
};

//受注ワーク取込データチェック(汎用)呼び出し処理
export const B010050ImportCheckgeneric = (props: B010050CheckRequest) => {
  return RestClient.post("b010050/import/checkgeneric", getFormData(props));
};

//受注ワーク取込データチェック(ハンズ)呼び出し処理
export const B010050ImportCheckhands = (props: B010050CheckRequest) => {
  return RestClient.post("b010050/import/checkhands", getFormData(props));
};

//受注ワーク取込データチェック(ロフト)呼び出し処理
export const B010050ImportCheckloft = (props: B010050CheckRequest) => {
  return RestClient.post("b010050/import/checkloft", getFormData(props));
};
